import { BodyDecoder } from '@iotize/tap/client/api';
import { BodyEncoder } from '@iotize/tap/client/api';
import { bufferToHexString } from '@iotize/common/byte-converter';

export class HexStringConverter
  implements BodyEncoder<string>, BodyDecoder<string>
{
  static _instance?: HexStringConverter = undefined;

  public decode(value: Uint8Array): string {
    return bufferToHexString(value);
  }

  public encode(value: string): Uint8Array {
    if (!value || value.length == 0) {
      return new Uint8Array(0);
    }
    if (value.length % 2 > 0) {
      // Prefix with 0
      value = '0' + value;
    }
    var result = [];
    for (var i = 0, len = value.length; i < len; i += 2) {
      result.push(parseInt(value.substr(i, 2), 16));
    }
    return new Uint8Array(result);
  }

  public static instance() {
    if (!HexStringConverter._instance) {
      HexStringConverter._instance = new HexStringConverter();
    }
    return HexStringConverter._instance;
  }
}
